import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const ApproverSelect = ({ value, onChange, excludeId, office }) => {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/approvers", { params: { office: office || "main" } }).then((r) => setList(r.data)); }, [office]);
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} data-testid="approver-select"
      className="w-full h-9 rounded-md border border-slate-300 bg-white text-sm px-2">
      <option value="">Select approver…</option>
      {list.filter((u) => u.user_id !== excludeId).map((u) => <option key={u.user_id} value={u.user_id}>{u.name} — {u.role.replace("_", " ")}</option>)}
    </select>
  );
};

export const ActionDialog = ({ cfg, onClose, onConfirm, record }) => {
  const [v, setV] = useState({ comment: "", approver: record?.assigned_to || "", confirm: "" });
  const [busy, setBusy] = useState(false);
  if (!cfg) return null;
  const ok = (!cfg.commentRequired || v.comment.trim()) && (!cfg.approver || v.approver) && (!cfg.confirmRef || v.confirm.trim().toUpperCase() === record.ref_no);
  const go = async () => { setBusy(true); try { await onConfirm(v); } finally { setBusy(false); } };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white" data-testid="action-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{cfg.title}</DialogTitle>
          {cfg.description && <DialogDescription>{cfg.description}</DialogDescription>}
        </DialogHeader>
        <div className="space-y-4">
          {cfg.approver && (
            <div className="space-y-1.5"><Label className="text-xs">Route to approver</Label>
              <ApproverSelect value={v.approver} onChange={(approver) => setV({ ...v, approver })} excludeId={record.created_by} office={record.office} /></div>
          )}
          {cfg.comment && (
            <div className="space-y-1.5"><Label className="text-xs">{cfg.commentLabel || "Comment"}{cfg.commentRequired && " *"}</Label>
              <Textarea rows={3} value={v.comment} onChange={(e) => setV({ ...v, comment: e.target.value })} data-testid="action-dialog-comment" /></div>
          )}
          {cfg.confirmRef && (
            <div className="space-y-1.5"><Label className="text-xs">Type <span className="font-mono font-bold">{record.ref_no}</span> to confirm</Label>
              <Input value={v.confirm} onChange={(e) => setV({ ...v, confirm: e.target.value })} className="font-mono" data-testid="action-dialog-confirm-ref" /></div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="action-dialog-cancel">Cancel</Button>
          <Button onClick={go} disabled={!ok || busy} className={cfg.danger ? "bg-rose-600 hover:bg-rose-700" : ""} data-testid="action-dialog-confirm">
            {busy && <Loader2 className="w-4 h-4 animate-spin mr-2" />}{cfg.cta}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
